import React from 'react';
import { connect } from 'react-redux';
import { State } from 'module/Redux';
import { RouterSelector } from 'module/Redux/Router';
import { PathUtils, createPureComponent } from 'module/Common';

type StateProps = {
  lang: PathUtils.Lang;
};

const mapStateToProps = (s: State): StateProps => ({
  lang: RouterSelector.selectLang(s),
});

type OwnProps = {
  children: (lang: PathUtils.Lang) => React.ReactNode;
};

type Props = OwnProps & StateProps;

const LangProviderComp = createPureComponent<Props>('LangProvider', ({ lang, children }) => {
  return <>{children(lang)}</>;
});

export const LangProvider = connect(mapStateToProps)(LangProviderComp);



// WEBPACK FOOTER //
// ./src/module/View/Common/component/LocalizedContent/LangProvider.tsx